import React from "react";
import LocksCard from "../../LocksCard/LocksCard";
import RoomDetails from "./RoomDetails";
import CustomerSection from "./CustomerSection";
import { isSameDay, isAfter } from "date-fns";
import clsx from "clsx";
import ReservationDetails from "../../ReservationDetails/ReservationDetails";

export default class ReservationSegmentCardDetails extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {

    var check_in_date = new Date(this.props.reservation_segment.check_in_date);
    var today = new Date();


    var check_in_today =
      isSameDay(check_in_date, today) &&
      this.props.reservation_segment.status != "checked_in";
    var check_out_today =
      isSameDay(
        new Date(this.props.reservation_segment.check_out_date),
        today
      ) &&
      (this.props.reservation_segment.status == "checked_in" ||
        this.props.reservation_segment.status == "checked_out");
    var past_check_out =
      isAfter(today, new Date(this.props.reservation_segment.check_out_date)) &&
      !check_out_today &&
      !check_in_today &&
      // this.props.reservation_segment.status == "checked_in" &&
      this.props.reservation_segment.status != "checked_out";
    var past_check_in =
      isAfter(today, new Date(this.props.reservation_segment.check_in_date)) &&
      !check_in_today &&
      !past_check_out &&
      this.props.reservation_segment.status != "checked_in";

    var tabClasses = clsx({
      active: this.props.active_tab == "details",
      "tab-pane": true,
    });
    var self = this;
    var statuses = [
      {
        value: 1,
        name: I18n.t("pending"),
      },
      {
        value: 2,
        name:
          this.props.reservation_segment.status == "checked_in"
            ? I18n.t("checked_in")
            : I18n.t("check_in"),
        href: `/admin/reservation_segments/${self.props.reservation_segment.id}/check_in`,
      },
      {
        value: 3,
        name:
          this.props.reservation_segment.status == "checked_out"
            ? I18n.t("checked_out")
            : I18n.t("check_out"),
        href: `/admin/reservation_segments/${self.props.reservation_segment.id}/check_out`,
      },
      {
        value: 4,
        name: I18n.t("cancel"),
      },
    ];
    var options = [];
    var value = 1;
    var classes = "btn btn-sm btn-secondary dropdown-toggle";
    var style = null;

    if (this.props.reservation_segment.status == "active") {
      options.push(statuses[0], statuses[1], statuses[3]);
    } else if (this.props.reservation_segment.status == "checked_in") {
      style = { color: "white" };
      value = 2;
      classes = "btn btn-sm btn-success dropdown-toggle";
      options.push(statuses[1], statuses[2]);
    } else if (this.props.reservation_segment.status == "checked_out") {
      style = { color: "white" };
      value = 3;
      options.push(statuses[2]);
    }

    return (
      <div
        className={tabClasses}
        id="details"
        ref="ReservationSegmentCardDetailsForm"
      >
        {this.renderErrors()}

        <div className="row">
          <RoomDetails
            {...this.props}
            check_in_date={check_in_date}
            today={today}
            check_in_today={check_in_today}
            check_out_today={check_out_today}
            past_check_out={past_check_out}
            past_check_in={past_check_in}
            daily_rental={this.props.reservation_segment && this.props.reservation_segment.room_type && this.props.reservation_segment.room_type.type_of_booking == "daily" ? true : false}
          />
          {this.props.reservation_segment.status != "held" ? (
            <div className="col-md-6">
              <CustomerSection {...this.props} />
              <LocksCard {...this.props} />
            </div>
          ) : null}
        </div>
        <div className="row">
          <div className="col-md-12">
            <ReservationDetails {...this.props} />
          </div>
        </div>
      </div>
    );
  }

  onChangeStatus(status) {
    if (status === 1) {
    } else if (status === 2) {
      this.checkIn();
    } else if (status === 3) {
      this.checkOut();
    }
  }

  renderErrors() {
    if (this.props.errors && this.props.errors.length) {
      var errors = this.props.errors.map(function (error, idx) {
        return <li key={idx}>{error}</li>;
      });
      return (
        <div className="alert alert-danger">
          <ul>{errors}</ul>
        </div>
      );
    } else {
      return null;
    }
  }

  buildMenu(name, id) {
    var menu =
      '<div class="popover-close-wrapper"><button type="button" class="close" onclick="$(this).parents(\'.popover\').popover(\'hide\');"><span aria-hidden="true">×</span><span class="sr-only">Close</span></button></div>';

    if (!this.props.readOnly) {
      menu +=
        "<a href='/admin/" +
        name +
        "/" +
        id +
        "/edit' class='btn btn-dark btn-block modal-iframe' data-fullscreen='true'>" +
        i18n.t("edit") +
        "</a>";
    }

    menu +=
      "<a href='/admin/" +
      name +
      "/" +
      id +
      "/show-details' class='btn btn-dark btn-block modal-iframe' data-fullscreen='true'>" +
      i18n.t("view") +
      "</a>";

    if (!this.props.readOnly) {
      menu +=
        "<a href='/admin/" +
        name +
        "/" +
        id +
        "/duplicate' class='btn btn-dark btn-block modal-iframe' data-fullscreen='true'>" +
        i18n.t("duplicate") +
        "</a>";
      menu +=
        "<a href='/admin/" +
        name +
        "/" +
        id +
        "/cancel' class='btn btn-dark btn-block modal-iframe' data-fullscreen='true'>" +
        i18n.t("cancel") +
        "</a>";
      menu +=
        "<a href='/admin/" +
        name +
        "/delete/" +
        id +
        "' class='btn btn-dark btn-block modal-iframe'>" +
        i18n.t("delete") +
        "</a>";
    }

    return menu;
  }
}
